import React from 'react';
import { useModal } from 'hooks/useModal';
import { AboutDataUpdateTimingModal } from '../modal/AboutDataUpdateTimingModal';

export const AccountAggregating = () => {
  const [isShowModal, { showModal, hideModal }] = useModal();
  return (
    <>
      <div className="max-w-md mx-auto relative pb-4">
        <div className="bg-white py-5.5 justify-center px-16">
          <div className="text-center text-bluegray-700 font-bold">
            データを準備しています
          </div>
          <div
            onClick={showModal}
            className="flex justify-center text-sm mt-1 text-bluegray-400 cursor-pointer">
            データ更新のタイミングについて
            <div className="icon-help_outline ml-2 mt-0.5"></div>
          </div>
          <AboutDataUpdateTimingModal {...{ isShowModal, hide: hideModal }} />
          <video className="mt-8" autoPlay loop muted>
            <source src="/static/images/data_loading.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </>
  );
};
